/*
 * Module for the exception correction view
*/

rs.module("content/employer/reporting/maintenance/exceptioncorrection",

    ["controls/components/event-banner", "common/lrs-scroll", "common/select-helper",],

    function (eventBanner, lrsScroll, selectHelper) {

        // Member variables
        var _jsSelectors;
        var _backendUrls;
        var _detailGrids;
        var _exceptionGrid;
        var _gridColumnIds;
        var _viewModes;
        var _cssClasses;
        var _batchRejectedOrInProgress;
        var _memberIsDeleted;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, detailGrids, exceptionGrid, gridColumnIds, viewModes, cssClasses, batchRejectedOrInProgress, memberIsDeleted, transmittalDetailKey, memberDetailType) {

            // Set member variables so functions defined outside initialize() have access to them
            _jsSelectors = jsSelectors;
            _backendUrls = backendUrls;
            _detailGrids = detailGrids;
            _exceptionGrid = exceptionGrid;
            _gridColumnIds = gridColumnIds;
            _viewModes = viewModes;
            _cssClasses = cssClasses;
            _batchRejectedOrInProgress = batchRejectedOrInProgress;
            _memberIsDeleted = memberIsDeleted;

            // this bool will be set to true in the click event of the delete button for each grid row
            // that event will fire just before the rowClicked() event, which will subsequently read this variable to know if the delete link was clicked
            // after reading the value of the variable, it will be reset to false 
            var forDelete = false;

            // Set forDelete variable when delete link is clicked
            $.js(_jsSelectors.deleteLink, { multiple: true, required: false }).click(function () { forDelete = true });

            /*
             * NOTE: We need to hook up both rowClicked event and selectionChanged events for each detail grid even though they are doing the same thing.
             *
             * We need the rowClicked event because we are using grid selection, and "same-page ajax" deletes, from the same grid
             * If we only used the selectionChanged event, once a row is selected, clicking it again (for delete) does nothing
             * The rowClicked event allows us to catch each time the row is clicked and not just when the selected row changes.
             *
             * However, when clicking an exception in the exceptions grid, we are also selecting the corresponding row in the detail grid
             * and showing the detail to edit.  The rowClicked event does not fire in this case since we aren't physcally clicking the row in the detail grid
             * but rather setting the selected row via js.  That is why we also need the selectionChanged event.
             *
             * Finally, these will BOTH fire when a detail row is clicked by the user, which we don't want.
             * Therefore we are setting a 'selectionTriggeredByClick' flag in the rowClick event and checking this in the selectionChanged event.
             * If the event was triggered by a click, then we don't do anything in the selectionChanged event since it was handled by rowClicked.
            */

            var selectionTriggeredByClick = false;

            // Loop through grids and hook up rowClicked and selectionChanged events on each one
            for (let grid in _detailGrids) {

                // Hook up rowClicked event for each detail grid
                _detailGrids[grid].rowClicked(function (values, rows) {

                    // set flag to indicate a row was physically clicked
                    selectionTriggeredByClick = true;

                    _exceptionGrid.selectedValues = null;

                    // clear other grids and load detail
                    _selectRow(this);
                });

                // variable used to stop selectionChanged event from running on intial load
                var initialLoad = true;

                // Hook up selectionChanged event for each detail grid
                _detailGrids[grid].selectionChanged(function (values, rows) {

                    // make sure this was not triggered by a physical click of a row
                    if (!selectionTriggeredByClick && values.length > 0 && !initialLoad) {

                        // clear other grids and load detail
                        _selectRow(this);
                    }

                    // reset flag
                    selectionTriggeredByClick = false;

                    // set initialLoad to false after this has been fired the first time
                    initialLoad = false;
                });
            }

            // When an add link is clicked, make the backend call to get an empty editor template
            $.js(_jsSelectors.addLink, { multiple: true }).click(function () {

                clearGridSelections();
                _exceptionGrid.selectedValues = null;

                // Load the detail
                loadDetail(
                    $(this).data("detailtype"),
                    null,
                    false
                );
            });

            // When a row is selected in the exceptions grid, select the corresponding row in the detail grids
            _exceptionGrid.rowClicked(function (values, rows) {

                if (values.length > 0) {

                    // Loop through detail grids to select the detail record with the exception
                    for (let grid in _detailGrids) {
                        _detailGrids[grid].selectedValues = rows[0][_gridColumnIds.recordKey];
                    }
                }
            });

            // Prevent exception grid row from being selected when a resolved checkbox is clicked
            $.js(_jsSelectors.resolvedCheckbox, { multiple: true, required: false }).click(function (e) { e.stopPropagation(); });

            // Create variables to hold the timeouts and saved status messages for each exceptions
            var statusSavedTimerDict = {};
            var savedStatusMessages = $.js(_jsSelectors.resolvedStatusSaveMessage, { multiple: true, required: false });

            // Make the call to update the status of the exception
            $.js(_jsSelectors.resolvedCheckbox, { multiple: true, required: false }).change(function () {
                var exceptionKey = $(this).data("exceptionkey");
                var savedMessage = savedStatusMessages.filter('[data-exceptionkey=' + exceptionKey + ']');

                $.post(
                    _backendUrls.toggleResolved,
                    {
                        detailExceptionKey: exceptionKey,
                        resolved: $(this).is(":checked")
                    }
                ).done(function (data) {
                    savedMessage.removeClass(cssClasses.failure);
                    savedMessage.html("Saved");
                    
                    // We want this to be moved to the back of the line to ensure it fires last
                    // Using setTimeout (even with a zero timeout) accomplishes this
                    setTimeout(function () {

                        // The update for exceptions potentially accesses the same table as the member detail (transmittaldtl)
                        // This means, if the member detail is showing when excpetions are resolved and the status is changed, the member detail form becomes stale
                        // and you will get a concurrency error when trying to save
                        // To fix this, we are re-retrieving/loading the member detail form if it was the current detail being displayed
                        if (getCurrentDetailType() == memberDetailType) {

                            loadDetail(
                                memberDetailType,
                                transmittalDetailKey,
                                false);
                        }
                            
                    }, 0);

                    var statusSelectHelper = selectHelper.getHelper($.js(jsSelectors.statusSelect));
                    if (data.memberStatusUpdated) {
                        if ($.js(jsSelectors.statusSelect).val() != data.memberStatus.key) {
                            statusSelectHelper.setValue(data.memberStatus.key);
                            eventBanner.removeAllMessages();
                            setTimeout(function () {
                                eventBanner.addInformationalMessages("The member's Status in Batch has been updated.");
                            }, 200);
                        }
                    }
                }).fail(function () {
                    savedMessage.addClass(cssClasses.failure);
                    savedMessage.html("Save Failed");
                }).always(function () {

                    // Each time status/warnings are saved, we want to reset the timeout for showing the saved message
                    clearTimeout(statusSavedTimerDict[exceptionKey]);

                    // Always hide the message first 
                    // In case it is already being shown for a previous save, we want it to "flash" to indicate a subsequent save
                    savedMessage.addClass(cssClasses.hidden);

                    // Show message that the status/warnings flag has been saved (wait a split second before showing to allow for "flash" - see above)
                    setTimeout(function () {
                        savedMessage.removeClass(cssClasses.hidden);
                    }, 200);

                    // Hide the message after 2 seconds
                    statusSavedTimerDict[exceptionKey] = setTimeout(function () {
                        savedMessage.addClass(cssClasses.hidden);
                    }, 2000);
                });
            });

            // Toggle the view to either detail, originally posted, or last posted
            $.js(_jsSelectors.viewRadioList).find("input").click(function () {

                clearGridSelections();
                _exceptionGrid.selectedValues = null;

                toggleViewMode($(this).val());
            });

            // needs to be inside document.ready since the grids need to be rendered before we can attach listeners to links inside them
            $(document).ready(function () {

                // Open the quick view popup for a member
                $.js(_jsSelectors.memberQuickViewLink).click(function (e) {

                    // we don't want the row to be selected when clicking the quickview link
                    e.stopPropagation();

                    $.get(_backendUrls.getMemberQuickView).done(function (result) {

                        $.js(_jsSelectors.quickViewDetail).html(result);
                        $.js(_jsSelectors.quickView).show();
                    });
                });

                // Open the quick view popup for a pay period
                $.js(_jsSelectors.payPeriodQuickViewLink, { multiple: true }).click(function (e) {

                    // we don't want the row to be selected when clicking the quickview link
                    e.stopPropagation();

                    $.get(
                        _backendUrls.getPayPeriodQuickView,
                        {
                            detailPayPeriodKey: $(this).data("detailpayperiodkey"),
                        }
                    ).done(function (result) {

                        $.js(_jsSelectors.quickViewDetail).html(result);
                        $.js(_jsSelectors.quickView).show();
                    });
                });
            });

            // Close the quick view popup
            $.js(_jsSelectors.quickViewCloseLink).click(function () {
                $.js(_jsSelectors.quickView).hide();
            });

            //
            // Pulling out the common code that the grids' rowClicked and selectionChanged events will both call
            //
            function _selectRow(lrsGridApi) {

                // When a row is selected in one of the grids we want to clear the selections in all of the other grids
                clearGridSelections({ exceptFor: lrsGridApi });

                // Load the detail for the selected row
                loadDetail(
                    lrsGridApi.agGridApi.pg.gridOptions.context.detailType,
                    lrsGridApi.selectedValues[0],
                    forDelete
                );

                // reset forDelete
                forDelete = false;
            }
        }

        //
        // Initialize status select and override warnings checkboxes
        // Note this is a separate initialize from the main initialize() function.  This is because we need these initialized right away.
        // We can't wait for the initialize() method to run 
        // As such, this function does not use the member variables defined for the whole module. It only uses those passed to it as parameters.
        //
        function initializeStatusAndWarnings(jsSelectors, backendUrls, cssClasses, transmittalDetailKey, memberDetailType) {

            // Hookup change event to toggle status
            $.js(jsSelectors.statusSelect).change(toggleStatusAndWarnings);

            // Hookup change event to toggle override warnings
            $.js(jsSelectors.warningsCheckbox).change(toggleStatusAndWarnings);

            // Create a variable to hold the timeout for showing the status saved message
            var statusSavedTimer;

            //
            // Function to update status and/or override warnings
            //
            function toggleStatusAndWarnings() {

                $.post(
                    // reset our error tracker
                    backendUrls.toggleStatusAndWarnings,
                    {
                        memberStatus: $.js(jsSelectors.statusSelect).val(),
                        overrideWarnings: $.js(jsSelectors.warningsCheckbox).is(":checked")
                    }
                ).done(function () {

                    $.js(jsSelectors.statusSaveMessage).removeClass(cssClasses.failure);
                    $.js(jsSelectors.statusSaveMessage).html("Saved");

                    // Since this could be called even before the rest of the page is ready (if the user has a fast trigger finger)
                    // We need to make sure the rest of the page is loaded before calling loadDetail()
                    $(document).ready(function () {

                        // Even though we wait for the document to be ready, we want this to be moved to the back of the line just to ensure it fires last
                        // Using setTimeout (even with a zero timeout) accomplishes this
                        setTimeout(function () {

                            // The update for status/warnings accesses the same table as the member detail (transmittaldtl)
                            // This means, if the member detail is showing when warnings override or status is changed, the member detail form becomes stale
                            // and you will get a concurrency error when trying to save
                            // To fix this, we are re-retrieving/loading the member detail form if it was the current detail being displayed
                            if (getCurrentDetailType() == memberDetailType) {

                                loadDetail(
                                    memberDetailType,
                                    transmittalDetailKey,
                                    false);
                            }

                        }, 0);
                    });
                }).fail(function () {
                    $.js(jsSelectors.statusSaveMessage).addClass(cssClasses.failure);
                    $.js(jsSelectors.statusSaveMessage).html("Save Failed");
                }).always(function () {

                    // Each time status/warnings are saved, we want to reset the timeout for showing the saved message
                    clearTimeout(statusSavedTimer);

                    // Always hide the message first 
                    // In case it is already being shown for a previous save, we want it to "flash" to indicate a subsequent save
                    $.js(jsSelectors.statusSaveMessage).addClass(cssClasses.hidden);

                    // Show message that the status/warnings flag has been saved (wait a split second before showing to allow for "flash" - see above)
                    setTimeout(function () {
                        $.js(jsSelectors.statusSaveMessage).removeClass(cssClasses.hidden);
                    }, 200);

                    // Hide the message after 2 seconds
                    statusSavedTimer = setTimeout(function () {
                        $.js(jsSelectors.statusSaveMessage).addClass(cssClasses.hidden);
                    }, 2000);
                });
            }
        }

        //
        // Make the backend call to get the detail and display the corresponding edit template 
        //
        function loadDetail(detailType, detailKey, forDelete) {

            $.get(
                _backendUrls.getDetail,
                {
                    detailType: detailType,
                    detailKey: detailKey,
                    forDelete: forDelete,
                    batchRejectedOrInProgress: _batchRejectedOrInProgress,
                    memberIsPostedOrDeleted: _memberIsDeleted
                }
            ).done(function (result) {

                $.js(_jsSelectors.detail).html(result);

                // always switch back to detail view when loading detail
                $.js(_jsSelectors.viewRadioList).find("input[value='" + _viewModes.detail + "']").prop('checked', true);
                toggleViewMode(_viewModes.detail);

                var form = $.js(_jsSelectors.detail).find("form");

                // Reset validation
                $.validator.resetValidation(form);
                
                eventBanner.removeAllMessages();

                // after rendering the editor template, intialize it for scrolling
                lrsScroll.initializeScroll($.js(_jsSelectors.detail).find(".lrs-scroll"));

                // if there is an exception selected in the exceptions grid, save it's key in a hidden field inside the detail form
                // this way we can reselect the same exception after an error
                $.js(_jsSelectors.exceptionKeyHiddenField).val(_exceptionGrid.selectedValues.length > 0 ? _exceptionGrid.selectedValues[0] : 0);
            });
        }

        //
        // Clear all grids, unless specified in 'exceptFor'
        //
        function clearGridSelections({ exceptFor } = {}) {

            // Loop through all of the grids to clear them
            for (let grid in _detailGrids) {

                // If a grid was passed in as the exceptFor argument, we want to skip it and not clear its value.
                // Else clear the selected value for all other grids
                if (!exceptFor || exceptFor != _detailGrids[grid]) {
                    _detailGrids[grid].selectedValues = null;
                }
            }
        }

        //
        // Toggle the detail section
        //
        function toggleViewMode(viewMode) {

            var detail = $.js(_jsSelectors.detail);
            var originallyReported = $.js(_jsSelectors.originallyReported);
            var lastPosted = $.js(_jsSelectors.lastPosted);

            if (viewMode == _viewModes.detail) {

                // Remove the _active class so that the current section fades out
                originallyReported.removeClass(_cssClasses.active);
                lastPosted.removeClass(_cssClasses.active);

                // There is a css transition for opacity happening when the _active class is toggled
                // We need to wait the same amount of time (.2s) before showing the new view
                setTimeout(function () {

                    originallyReported.addClass(_cssClasses.hidden);
                    lastPosted.addClass(_cssClasses.hidden);

                    detail.removeClass(_cssClasses.hidden);

                    // We need to wait a split second before adding the _active class so the transition takes effect
                    setTimeout(function () {
                        detail.addClass(_cssClasses.active);
                    }, 100);

                }, 200);
            }
            else if (viewMode == _viewModes.original) {

                var comingFromDetail = detail.hasClass(_cssClasses.active);

                // Remove the _active class so that the current section fades out
                detail.removeClass(_cssClasses.active);
                lastPosted.removeClass(_cssClasses.active);

                // Order of operations matters here due to the order of the sections in the markup
                // If the current view is detail, then we need to remove the hidden class right away
                if (comingFromDetail) {
                    originallyReported.removeClass(_cssClasses.hidden);
                }

                // There is a css transition for opacity happening when the _active class is toggled
                // We need to wait the same amount of time (.2s) before showing the new view
                setTimeout(function () {

                    detail.addClass(_cssClasses.hidden);
                    lastPosted.addClass(_cssClasses.hidden);

                    // If the current view is not detail, then we need to remove the hidden class after the .2s delay
                    if (!comingFromDetail) {
                        originallyReported.removeClass(_cssClasses.hidden);
                    }

                    // We need to wait a split second before adding the _active class so the transition takes effect
                    setTimeout(function () {
                        originallyReported.addClass(_cssClasses.active);
                    }, 100);

                }, 200);
            }
            else if (viewMode == _viewModes.lastPosted) {

                // Remove the _active class so that the current section fades out
                detail.removeClass(_cssClasses.active);
                originallyReported.removeClass(_cssClasses.active);

                lastPosted.removeClass(_cssClasses.hidden);

                // There is a css transition for opacity happening when the _active class is toggled
                // We need to wait the same amount of time (.2s) before showing the new view
                setTimeout(function () {

                    detail.addClass(_cssClasses.hidden);
                    originallyReported.addClass(_cssClasses.hidden);

                    // We need to wait a split second before adding the _active class so the transition takes effect
                    setTimeout(function () {
                        lastPosted.addClass(_cssClasses.active);
                    }, 100);

                }, 200);
            }
        }

        //
        // Return what detail type is currently being displayed
        //
        function getCurrentDetailType() {

            return $.js(_jsSelectors.detail).js(_jsSelectors.detailTypeHiddenField).val();
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            initializeStatusAndWarnings: initializeStatusAndWarnings
        };

        return exports;
    }
);